import { httpClient } from './http';

export interface RestaurantData {
  id: string;
  name: string;
  description?: string;
  address: string;
  phone: string;
  email?: string;
  cuisine: string;
  deliveryTime: string; // Tiempo de entrega como string
  isOpen?: boolean;
  rating?: number;
  createdAt?: string;
  updatedAt?: string;
  image?: string; // Agregar campo de imagen
}

export interface CreateRestaurantData {
  name: string;
  description?: string;
  address: string;
  phone: string;
  cuisine: string;
  delivery_time: string; // Tiempo de entrega como string
  image?: string; // Agregar campo de imagen
}

export interface UpdateRestaurantData {
  name?: string;
  description?: string;
  address?: string;
  phone?: string;
  email?: string;
  cuisine?: string;
  delivery_time?: string;
  isOpen?: boolean;
  image?: string; // Agregar campo de imagen
  is_update_image?: boolean; // Flag para indicar si se está actualizando la imagen
  onboarding?: any; // Config y layout
}

// Servicio para gestión de restaurantes en admin
export const adminRestaurantsService = {
  // Obtener restaurantes del usuario
  getRestaurants: async (userId: string) => {
    return httpClient.get(`/system/users/${userId}/restaurants`, undefined, 'authenticated');
  },

  // Crear restaurante
  createRestaurant: async (userId: string, data: any) => {
    return httpClient.post(`/system/users/${userId}/restaurants`, data, 'authenticated');
  },

  // Actualizar restaurante
  updateRestaurant: async (userId: string, restaurantId: string, data: any) => {
    return httpClient.put(`/system/users/${userId}/restaurants/${restaurantId}`, data, 'authenticated');
  },
  // Obtener restaurante por id
  getRestaurantById: async (userId: string, restaurantId: string) => {
    return httpClient.get(`/system/users/${userId}/restaurants/${restaurantId}`, undefined, 'authenticated');
  },

  // Eliminar restaurante
  deleteRestaurant: async (userId: string, restaurantId: string) => {
    return httpClient.delete(`/system/users/${userId}/restaurants/${restaurantId}`, 'authenticated');
  },

  // Cambiar estado del restaurante (abrir/cerrar)
  toggleRestaurantStatus: async (userId: string, restaurantId: string, isOpen: boolean) => {
    try {
      console.log('🏪 Cambiando estado del restaurante:', { restaurantId, isOpen });
      const response = await httpClient.put(
        `/system/users/${userId}/restaurants/${restaurantId}`, 
        { is_open: isOpen },
        'authenticated'
      );
      console.log('✅ Estado del restaurante cambiado:', response);
      return response;
    } catch (error) {
      console.error('❌ Error cambiando estado del restaurante:', error);
      throw error;
    }
  },



  // Categorías
  getCategories: async (userId: string, restaurantId: string) => {
    return httpClient.get(`/system/users/${userId}/restaurants/${restaurantId}/categories`, undefined, 'authenticated');
  },
  createCategory: async (userId: string, restaurantId: string, data: any) => {
    return httpClient.post(`/system/users/${userId}/restaurants/${restaurantId}/categories`, data, 'authenticated');
  },
  updateCategory: async (userId: string, restaurantId: string, categoryId: string, data: any) => {
    return httpClient.put(`/system/users/${userId}/restaurants/${restaurantId}/categories/${categoryId}`, data, 'authenticated');
  },
  deleteCategory: async (userId: string, restaurantId: string, categoryId: string) => {
    return httpClient.delete(`/system/users/${userId}/restaurants/${restaurantId}/categories/${categoryId}`, 'authenticated');
  },

  // Menú
  getMenuItems: async (userId: string, restaurantId: string) => {
    return httpClient.get(`/system/users/${userId}/restaurants/${restaurantId}/menu`, undefined, 'authenticated');
  },
  createMenuItem: async (userId: string, restaurantId: string, data: any) => {
    return httpClient.post(`/system/users/${userId}/restaurants/${restaurantId}/menu`, data, 'authenticated');
  },
  updateMenuItem: async (userId: string, restaurantId: string, menuItemId: string, data: any) => {
    return httpClient.put(`/system/users/${userId}/restaurants/${restaurantId}/menu/${menuItemId}`, data, 'authenticated');
  },
  deleteMenuItem: async (userId: string, restaurantId: string, menuItemId: string) => {
    return httpClient.delete(`/system/users/${userId}/restaurants/${restaurantId}/menu/${menuItemId}`, 'authenticated');
  },
}; 